import { createStore, createLogger } from "vuex";
import auth from "./modules/auth";
import host from "./modules/host";
import core from "./modules/core";
import features from "./modules/features";

const debug = process.env.NODE_ENV !== "production";

export default createStore({
  modules: {
    auth,
    host,
    core,
    features,
  },
  strict: debug,
  plugins: debug ? [createLogger()] : [],
});
